import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/ServiceDetails.css";
import WhatsAppFloat from "../components/WhatsAppFloat"

function Tourism() {
  return (
    
    <div>
      <Navbar />

      <section className="service-detail">

        <h1>Tourism / Visitor Visa Services</h1>

        <p className="intro">
          At our travel agency, we specialize in providing <b>seamless and reliable Tourism and Visitor Visa assistance</b>
          for individuals and families planning to travel abroad for leisure, vacation, sightseeing, or to visit friends and relatives.
          We make the entire process <i>simple, stress-free, and well-guided</i>.
        </p>

        <img
          src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=900&auto=format&fit=crop&q=60"
          alt="Tourism Travel"
          className="service-image"
        />

        <div className="content">

          
          <h2>What is a Tourism / Visitor Visa?</h2>
          <p>
            A <b>Tourism or Visitor Visa</b> is an official travel document issued by a foreign country that allows travelers
            to enter temporarily for non-business purposes. This includes holidays, tourism, family visits, cultural exploration,
            or short recreational stays.
          </p>

          <p>
            Each country has its own requirements, processing times, and eligibility criteria.
            <i> We simplify these requirements and guide you through every step.</i>
          </p>

          
          <h2>Our Tourism Visa Services Include</h2>

          <h3>1. Professional Consultation</h3>
          <p>
            We provide one-on-one consultation to help you choose the right visa type based on your travel purpose,
            destination, and duration of stay. Our experts guide you on the best application strategy.
          </p>

          <h3>2. Document Guidance and Verification</h3>
          <p>
            We assist in preparing and organizing all required documents such as:
          </p>

          <ul>
            <li>Valid international passport</li>
            <li>Completed visa application forms</li>
            <li>Proof of funds (bank statements, financial records)</li>
            <li>Travel itinerary and flight reservations</li>
            <li>Hotel bookings or accommodation details</li>
            <li>Invitation letters (if applicable)</li>
            <li>Employment or school verification documents</li>
          </ul>

          <p>
            We ensure all documents meet embassy standards to reduce rejection risks.
          </p>

          <h3>3. Application Form Filling</h3>
          <p>
            We help you accurately complete visa application forms to avoid errors that could cause delays or rejection.
          </p>

          <h3>4. Appointment Scheduling</h3>
          <p>
            We assist in booking visa appointments at embassies, consulates, or visa application centers.
          </p>

          <h3>5. Travel Itinerary Planning</h3>
          <p>
            A strong travel plan increases approval chances. We design realistic itineraries including flights,
            hotels, and travel activities.
          </p>

          <h3>6. Travel Insurance Assistance</h3>
          <p>
            We help you obtain affordable and embassy-approved travel insurance for your trip.
          </p>

          <h3>7. Interview Preparation</h3>
          <p>
            For countries requiring interviews, we prepare you with mock sessions and guidance.
          </p>

          <h3>8. Visa Tracking & Updates</h3>
          <p>
            We monitor your application and provide updates until a final decision is made.
          </p>

          
          <h2>Why Choose Our Agency?</h2>

          <ul>
            <li>High success rate in visa approvals</li>
            <li>Experienced travel consultants</li>
            <li>Fast and reliable processing support</li>
            <li>Transparent guidance with no hidden steps</li>
            <li>Personalized client support</li>
            <li>Strong global embassy knowledge</li>
          </ul>

          <p>
            We are committed to making your travel dreams a reality with <i>maximum efficiency and minimum stress</i>.
          </p>

          
          <h2>Popular Destinations We Cover</h2>

          <ul>
            <li>Canada</li>
            <li>United Kingdom</li>
            <li>United States</li>
            <li>Schengen Countries (Europe)</li>
            <li>Dubai / UAE</li>
            <li>Australia</li>
            <li>Turkey</li>
            <li>South Africa and more</li>
          </ul>

          
          <h2>Start Your Travel Journey Today</h2>

          <p>
            Whether you are planning a holiday, visiting loved ones, or exploring new destinations,
            our Tourism Visa service is designed to make your journey smooth from start to finish.
          </p>

          <p>
            <b>Contact us today</b> to begin your visa application process and take the first step toward your next adventure!
          </p>
          

        </div>

      </section>

      <Footer />
      <WhatsAppFloat/>
    </div>

    
  );
}

export default Tourism;